"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../../../shared");

var Body_meta_1 = require("./Body.meta");

var TableComponentBase_1 = require("../TableComponentBase");

var Row_1 = __importDefault(require("../Row"));

var mobx_1 = require("mobx");

var Body =
/** @class */
function (_super) {
  __extends(Body, _super);

  function Body(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Body_meta_1.BODY_CATEGORY_KEY;
    _this.componentKey = Body_meta_1.BODY_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(Body.prototype, "parentComponentKey", {
    get: function get() {
      return Body_meta_1.BODY_PARENT_COMPONENT_KEY;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Body.prototype, "tableEventsKey", {
    get: function get() {
      return 'body';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Body.prototype, "grouping", {
    get: function get() {
      return this.table && this.table.grouping;
    },
    enumerable: true,
    configurable: true
  });

  Body.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        configuration = _a.configuration,
        componentStyle = _a.componentStyle,
        componentStyleProps = _a.componentStyleProps,
        table = _a.table,
        _b = _a.rows,
        rows = _b === void 0 ? [] : _b,
        otherProps = __rest(_a, ["children", "configuration", "componentStyle", "componentStyleProps", "table", "rows"]);

    var events = this.getEvents(this.eventsForElement);
    return react_1.default.createElement("tbody", __assign({}, events, otherProps), rows.map(function (row, rowIndex) {
      var key = _this.getRowKey(row, rowIndex);

      var rowStyleProps = _this.getRowStyleProps(row, rowIndex, _this.grouping);

      return react_1.default.createElement(Row_1.default, __assign({}, rowStyleProps, {
        key: key,
        table: table,
        row: row,
        rowIndex: rowIndex,
        grouping: _this.grouping
      }));
    }));
  };

  __decorate([mobx_1.computed], Body.prototype, "grouping", null);

  Body = __decorate([mobx_react_1.observer], Body);
  return Body;
}(TableComponentBase_1.TableComponentBase);

exports.Body = Body;
exports.default = shared_1.InjectedStyledComponent(Body, Body_meta_1.BODY_CATEGORY_KEY, Body_meta_1.BODY_PARENT_COMPONENT_KEY, [Body_meta_1.BODY_COMPONENT_KEY]);